export default "__VITE_ASSET__a910a5d5__"